import styled from 'styled-components';

const DefaultSpan = styled.span`
  padding: 5px 0;
  font-weight: 400;
  @media only screen and (min-width: 1024px) {
    padding: 0;
  }
`;

export default DefaultSpan;
